module.exports = __webpack_public_path__ + "images/bannerPT-a8f075cc459cafeb3773e0f96d4244a8.png";